export const createManageSchedulerFilters = (set, get) => ({
    manageSchedulerFilters: {  // ✅ Different unique key
        searchName: undefined,
        userType: undefined,
    },
    setManageSchedulerFilters: (newFilter) =>
        set((state) => ({
            manageSchedulerFilters: {
                ...state.manageSchedulerFilters,
                ...newFilter,
            },
        })),
});



// WEBPACK FOOTER //
// ./src/store/slices/ManageSchedulersSlice/ManageSchedulerSlice.js